import { ViewsEnum } from "@pages/Dashboard/contexts/Filter.context";
import { useMemo } from "react";
import { useGetGantt } from "./useGetGantt";
import { useGetManagement } from "./useGetManagement";

const transformGanttToTimeline = (
  data: Sentinel.Timeline.GanttResponse
): Sentinel.Timeline.New =>
  ({
    lanedEvents: [{ laneId: 1, groupedEvents: data.groupedEvents }],
  }) as Sentinel.Timeline.New;

export const useGetTimeline = (date: Date, view?: ViewsEnum) => {
  const isDetailed = view === ViewsEnum.detalhada;
  const managementQuery = useGetManagement(date, !isDetailed);
  const ganttQuery = useGetGantt(date, isDetailed);

  const activeQuery = isDetailed ? ganttQuery : managementQuery;

  const data = useMemo(
    () =>
      isDetailed
        ? ganttQuery.data?.groupedEvents?.length
          ? transformGanttToTimeline(ganttQuery.data)
          : undefined
        : managementQuery.data,
    [isDetailed, ganttQuery.data, managementQuery.data]
  );

  return {
    data,
    isLoading: activeQuery.isLoading,
    isFetching: activeQuery.isFetching,
    isFetched: activeQuery.isFetched,
  };
};
